import { UnstyledButton } from "@mantine/core";
import React from "react";
import { IHeaderProps } from "../IHeaderProps";
import { FullscreenClose, FullscreenOpen } from "../../../../../Icons";

/**
 * Кнопка с входом в полноэкранный режим
 */
export const FullScreenSection = (props: Pick<IHeaderProps, "fullscreen" | "fullscreenToggle">) => {
	const clickHandler = () => {
		if (!props.fullscreenToggle) return;
		void props.fullscreenToggle();
	};
	if (!document.fullscreenEnabled) {
		log.info("Fullscreen not supported...");
		return null;
	}
	return (
		<div className={`header-action header-fullscreen${props?.fullscreen ? " active" : ""}`}>
			<UnstyledButton onClick={clickHandler} sx={{ display: "inline-flex", alignItems: "center" }}>
				<div className="header-fullscreen-open">
					<FullscreenOpen stroke="#fff" width={16} height={16} />
				</div>
				<div className="header-fullscreen-close">
					<FullscreenClose stroke="#fff" width={16} height={16} />
				</div>
			</UnstyledButton>
		</div>
	);
};
